import { render, staticRenderFns } from "./starList.vue?vue&type=template&id=234fd2e9"
import script from "./starList.vue?vue&type=script&lang=js"
export * from "./starList.vue?vue&type=script&lang=js"
import style0 from "./starList.vue?vue&type=style&index=0&id=234fd2e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports